import { defineStore } from "pinia";
import { privateBoaHttp } from "@/boa-api-client";
import fixedEncodeURIComponent from "@/util/fixed-encode-uri-component";

type State = {
  "delete-inactive-candidates": any;
};

export default defineStore("jobs", {
  state: (): State => {
    return {
      "delete-inactive-candidates": {
        key: "delete-inactive-candidates",
      },
    };
  },
  actions: {
    async getJobStatus() {
      try {
        const response: {
          jobs: {
            jobName: string;
            jobId: string;
            running: boolean;
            started?: string;
            finished?: string;
          }[];
        } = await privateBoaHttp.get("jobs").json();
        for (const job of response.jobs) {
          this[job.jobName] = job;
        }
        return response.jobs;
      } catch (error: any) {
        const { message } = await (error as any).response.json();
        return { message };
      }
    },
    async submitJob(jobName: string, params?: Record<string, string>) {
      try {
        const response = await privateBoaHttp
          .post(`jobs/${fixedEncodeURIComponent(jobName)}`, {
            json: { params },
          })
          .json<{ jobId: string }>();
        this[jobName].jobId = response.jobId;
        return { jobId: response.jobId };
      } catch (error: any) {
        const { message } = await (error as any).response.json();
        return { message };
      }
    },
    clear() {
      this.$reset();
    },
  },
});
